import {
  Card,
  Button,
  Footer,
  Toast,
  Loader,
  AlertCard,
  TextBlock,
} from "@egovernments/digit-ui-components";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import validateBoundaryExcelContent from "../../utils/validateBoundaryExcel";

const DEFAULT_MDMS_MODULENAME = "HCM-ADMIN-CONSOLE";
import BulkUploadNew from "../../components/BulkUploadNew";
import { CustomSVG } from "@egovernments/digit-ui-components";

const ViewHierarchy = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const searchParams = new URLSearchParams(location.search);
  const defaultHierarchyType = searchParams.get("defaultHierarchyType");
  const hierarchyType = searchParams.get("hierarchyType");
  const locale =
    Digit?.SessionStorage.get("initData")?.selectedLanguage || "en_IN";
  const inputRef = useRef(null); // Ref to trigger file input
  const [defData, setDefData] = useState([]);
  const [hierData, setHierData] = useState([]);
  const [fileUrl, setFileUrl] = useState("");
  const [fileData, setFileData] = useState({});
  const [fileStoreId, setFileStoreId] = useState("");
  const [fileName, setFileName] = useState("");
  const [showToast, setShowToast] = useState(null); // State to handle toast notifications
  const [dataCreateToast, setDataCreateToast] = useState(false);
  const [disable, setDisable] = useState(false);
  const [disableFile, setDisableFile] = useState(true);
  const [dataCreationGoing, setDataCreationGoing] = useState(false);
  const [noOfRows, setNoOfRows] = useState(100);

  const mdmsModuleName =
    location.state?.mdmsModuleName ||
    window?.globalConfigs?.getConfig("DEFAULT_MDMS_MODULENAME") ||
    DEFAULT_MDMS_MODULENAME;

  const { data: baseTimeOut } = Digit.Hooks.useCustomMDMS(
    tenantId,
    mdmsModuleName,
    [{ name: "baseTimeOut" }]
  );
  const callSearch = async (hierarchy) => {
    const res = await Digit.CustomService.getResponse({
      url: `/boundary-service/boundary-hierarchy-definition/_search`,
      body: {
        BoundaryTypeHierarchySearchCriteria: {
          tenantId: tenantId,
          limit: 2,
          offset: 0,
          hierarchyType: hierarchy,
        },
      },
    });
    return res;
  };
  const language = Digit.StoreData.getCurrentLanguage();
  const modulePrefix = "hcm";
  const stateCode = Digit.ULBService.getCurrentTenantId();
  const moduleCode = hierarchyType
    ? `boundary-${hierarchyType.toLowerCase()}`
    : "";
  const { isLoading, data } = Digit.Services.useStore({
    stateCode,
    moduleCode,
    language,
    modulePrefix,
  });

  const [viewState, setViewState] = useState(false);
  const fetchData = async () => {
    try {
      const res = await callSearch(defaultHierarchyType);
      if (res?.BoundaryHierarchy?.[0]?.boundaryHierarchy)
        setDefData(res?.BoundaryHierarchy?.[0]?.boundaryHierarchy);
      const res1 = await callSearch(hierarchyType);
      if (res1?.BoundaryHierarchy?.[0]?.boundaryHierarchy)
        setHierData(res1?.BoundaryHierarchy?.[0]?.boundaryHierarchy);
      setViewState(true);
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);
  const generateTemplate = async () => {
    const res = await Digit.CustomService.getResponse({
      url: `/boundary-management/v1/_generate-search`,
      body: {},
      params: {
        tenantId: tenantId,
        hierarchyType: hierarchyType,
      },
    });
    return res;
  };
  const downloadExcelTemplate = async () => {
    // const res = await generateFile()
    const resFile = await generateTemplate();
    if (resFile && resFile?.GeneratedResource?.[0]?.fileStoreid) {
      // Splitting filename before .xlsx or .xls
      const fileNameWithoutExtension = hierarchyType;
      Digit.Utils.workbench.downloadExcelWithCustomName({
        fileStoreId: resFile?.GeneratedResource?.[0]?.fileStoreid,
        customName: fileNameWithoutExtension,
      });
      setShowPopUp(false);
    } else if (
      resFile &&
      resFile?.GeneratedResource?.[0]?.status === "inprogress"
    ) {
      setShowToast({
        label: t("PLEASE_WAIT_AND_RETRY_AFTER_SOME_TIME"),
        isError: "info",
      });
      setShowPopUp(false);
    } else {
      setShowToast({
        label: t("PLEASE_WAIT_AND_RETRY_AFTER_SOME_TIME"),
        isError: "info",
      });
      setShowPopUp(false);
    }
  };

  const [uiValError, setUiValError] = useState(false);
  const [uiErrorMsg, setUiErrorMsg] = useState("");

  const handleUpload = () => {
    inputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name);
      // Check file extension
      const validExtensions = ["xls", "xlsx"];
      const fileExtension = file.name.split(".").pop().toLowerCase(); // Get the file extension

      if (!validExtensions.includes(fileExtension)) {
        setShowToast({ label: t("INVALID_FILE_FORMAT"), isError: "error" });
        setDisableFile(true);
        event.target.value = "";
        return; // Exit the function if the file is not valid
      }
      try {
        // Parse the file and validate its content
        const isValid = await validateBoundaryExcelContent(file, t, hierData?.length);
        if (!isValid.success) {
          // setShowToast({ label: isValid.error, isError: "error" });
          setUiValError(true);
          setUiErrorMsg(isValid.error);
          setDisableFile(true);
          event.target.value = "";
          return; // Exit if validation fails
        }
        // Call function to upload the validated file to an API
        await uploadFileToAPI([file]);
        setDisableFile(false);
        setUiValError(false);
        setShowToast({
          label: t("FILE_UPLOADED_SUCCESSFULLY"),
          isError: "success",
        });
      } catch (error) {
        event.target.value = "";
        setShowToast({
          label:
            error?.response?.data?.Errors?.[0]?.message ||
            t("FILE_UPLOAD_FAILED"),
          isError: "error",
        });
      }
    }
  };

  const uploadFileToAPI = async (files) => {
    const module = "HCM";
    let file = files[0];
    let fileDataTemp = {};
    fileDataTemp.fileName = file?.name;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      // Assume the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      // Convert sheet to JSON and count rows
      const rows = XLSX.utils.sheet_to_json(sheet);
      // After parsing locally, upload to API
      const response = await Digit.UploadServices.Filestorage(
        module,
        file,
        tenantId
      );
      fileDataTemp.fileStoreId = response?.data?.[0]?.fileStoreId;
      let fileStoreIdTemp = response?.data?.files?.[0]?.fileStoreId;
      setFileStoreId(response?.data?.files?.[0]?.fileStoreId);
      const {
        data: { fileStoreIds: fileUrlTemp } = {},
      } = await Digit.UploadServices.Filefetch([fileStoreIdTemp], tenantId);
      fileDataTemp.url = fileUrlTemp?.[0]?.url;
      setFileUrl(fileDataTemp?.url);
      setFileData(fileDataTemp);
    };
    reader.readAsArrayBuffer(file); // Read the file as an array buffer
  };

  const callCreateDataApi = async () => {
    setDisable(true);
    setDataCreationGoing(true);
    try {
      setDataCreateToast(true);

      const createResponse = await Digit.CustomService.getResponse({
        url: "/boundary-management/v1/_process",
        params: {},
        body: {
          ResourceDetails: {
            tenantId: tenantId,
            fileStoreId: fileStoreId,
            action: "create",
            hierarchyType: hierarchyType,
            additionalDetails: {},
          },
        },
      });

      const id = createResponse?.ResourceDetails?.id;
      const typeOfData = createResponse?.ResourceDetails?.type;

      if (id) {
        try {
          await pollForStatusCompletion(id, typeOfData);
          setDataCreateToast(false);
          navigate(
            `/${
              window.contextPath
            }/employee/workbench/boundary/response?isSuccess=${true}`,
            {
              state: {
                message: "ES_BOUNDARY_DATA_CREATED_SUCCESS_RESPONSE",
                preText: "ES_BOUNDARY_DATA_CREATED_SUCCESS_RESPONSE_PRE_TEXT",
                actionLabel: "CS_BOUNDARY_DATA_NEW_RESPONSE_ACTION",
                actionLink: `/${window.contextPath}/employee/workbench/boundary/data?defaultHierarchyType=${defaultHierarchyType}&hierarchyType=${hierarchyType}`,
                secondaryActionLabel: "CS_HOME",
                secondaryActionLink: `/${window?.contextPath}/employee`,
                mdmsModuleName,
              },
            }
          );
          // setShowToast({ label: `${t("WBH_HIERARCHY_CREATED")}`, isError: "success" });
        } catch (pollError) {
          throw pollError; // Propagate polling errors to the outer catch block
        }
      }

      return createResponse;
    } catch (error) {
      setDisable(false);
      let label;

      // Handle known errors like polling timeout and max retries
      if (
        error.message === "Polling timeout" ||
        error.message === "Max retries reached"
      ) {
        label = `${t("WBH_BOUNDARY_CREATION_TIMEOUT")}: ${t(
          "WBH_OPERATION_INCOMPLETE"
        )}`;
      } else {
        // Initialize the label with a failure message
        label = `${t("WBH_BOUNDARY_CREATION_FAIL")}: `;
        if (error?.message) label += `${t(error?.message)}`; // the message here is sent from the polling mechnism which sendds the error code from backend.
      }

      setShowToast({ label, isError: "error" });
      setDataCreationGoing(false);
      return {};
    }
  };

  const pollForStatusCompletion = async (id, typeOfData) => {
    // const pollInterval = 2000; // Poll every 1 second
    const maxRetries = 20; // Maximum number of retries
    let retries = 0;
    const baseDelay =
      baseTimeOut?.[mdmsModuleName]?.baseTimeOut?.[0]?.baseTimeOut;
    const maxTime = baseTimeOut?.[mdmsModuleName]?.baseTimeOut?.[0]?.maxTime;
    const pollInterval = Math.max(baseDelay * noOfRows, maxTime);

    return new Promise((resolve, reject) => {
      const poll = async () => {
        try {
          // if (retries >= maxRetries) {
          //   setDataCreationGoing(false);
          //   reject(new Error("Max retries reached"));
          //   return;
          // }

          const searchResponse = await Digit.CustomService.getResponse({
            // url: "/project-factory/v1/data/_search",
            url: "/boundary-management/v1/_process-search",
            params: {},
            body: {
              SearchCriteria: {
                id: [id],
                tenantId: tenantId,
                type: typeOfData,
              },
            },
          });

          const status = searchResponse?.ResourceDetails?.[0]?.status;
          let errorString =
            searchResponse?.ResourceDetails?.[0]?.additionalDetails?.error;
          let errorObject = {};
          let errorCode = "HIERARCHY_FAILED";
          if (errorString) errorObject = JSON.parse(errorString);
          if (errorObject) errorCode = errorObject.code;

          if (status === "completed") {
            setShowToast({
              label: `${t("WBH_HIERARCHY_STATUS_COMPLETED")}`,
              isError: "success",
            });
            setDataCreationGoing(false);
            resolve(true);
          } else if (status === "failed") {
            const humanMessage =
              errorObject.description ||
              errorObject.code ||
              "WBH_HIERARCHY_STATUS_FAILED";
            reject(new Error(humanMessage));
          } else {
            retries++;
            setTimeout(poll, pollInterval);
          }
        } catch (error) {
          // console.error("Error while polling:", error);
          retries++;
          setTimeout(poll, pollInterval);
        }
      };

      // Start the polling
      poll().catch(reject);
    });
  };

  const createData = async () => {
    const res = await callCreateDataApi();
  };
  const trimming = (val) => {
    return `${t(
      (hierarchyType + "_" + val.trim().replace(/[\s_]+/g, "")).toUpperCase()
    )}`;
  };

  const removeFile = () => {
    setFileName("");
    setDisableFile(true);
  };

  const [showPopUp, setShowPopUp] = useState(false);

  // New state for BulkUploadNew component
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const { XlsxFile } = CustomSVG;

  // Handler for file upload via BulkUploadNew
  const handleBulkUploadSubmit = async (files) => {
    const file = files[0];
    if (!file) return;

    // Check file extension
    const validExtensions = ["xls", "xlsx"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      setShowToast({ label: t("INVALID_FILE_FORMAT"), isError: "error" });
      return;
    }

    try {
      // Validate file content
      const isValid = await validateBoundaryExcelContent(file, t, hierData?.length);
      if (!isValid.success) {
        setUiValError(true);
        setUiErrorMsg(isValid.error);
        setShowToast({ label: isValid.error, isError: "error" });
        return;
      }

      // Upload file to filestore
      const module = "HCM";
      const response = await Digit.UploadServices.Filestorage(
        module,
        file,
        tenantId
      );
      const fileStoreIdTemp = response?.data?.files?.[0]?.fileStoreId;

      if (fileStoreIdTemp) {
        setFileStoreId(fileStoreIdTemp);
        const {
          data: { fileStoreIds: fileUrlTemp } = {},
        } = await Digit.UploadServices.Filefetch([fileStoreIdTemp], tenantId);

        const newFileData = {
          filename: file.name,
          filestoreId: fileStoreIdTemp,
          url: fileUrlTemp?.[0]?.url,
        };

        setUploadedFileData([newFileData]);
        setFileUrl(fileUrlTemp?.[0]?.url);
        setFileData(newFileData);
        setFileName(file.name);
        setDisableFile(false);
        setUiValError(false);
        setShowToast({
          label: t("FILE_UPLOADED_SUCCESSFULLY"),
          isError: "success",
        });
      }
    } catch (error) {
      setShowToast({
        label:
          error?.response?.data?.Errors?.[0]?.message ||
          t("FILE_UPLOAD_FAILED"),
        isError: "error",
      });
    }
  };

  // Handler for file delete
  const handleFileDelete = (file, index) => {
    setUploadedFileData([]);
    setFileStoreId("");
    setFileUrl("");
    setFileData({});
    setFileName("");
    setDisableFile(true);
  };

  // Handler for file download
  const handleFileDownload = (file) => {
    if (file?.url) {
      Digit.Utils.workbench.downloadExcelWithCustomName({
        fileStoreId: file?.filestoreId,
        customName: file?.filename?.replace(/\.[^/.]+$/, "") || hierarchyType,
      });
    }
  };

  if (!viewState || isLoading) {
    return <Loader page={true} variant={"PageLoader"} />;
  } else {
    return (
      <React.Fragment>
        <div className="boundary-management-wrapper">
          {/* First Card: Hierarchy Levels */}
          <Card
            type={"primary"}
            variant={"viewcard"}
            className={"example-view-card"}
          >
            <div className="hierarchy-boundary-heading">
              {t(`HIERARCHY`)} {hierarchyType}
            </div>
            {/* Hierarchy Levels */}
            {hierData.map((hierItem, index) => {
              const isLessThanDefData = index < defData.length;

              if (isLessThanDefData) {
                if (hierItem?.boundaryType === defData[index]?.boundaryType) {
                  return (
                    <div key={index}>
                      <div className="hierarchy-boundary-sub-heading2">
                        {trimming(hierItem?.boundaryType)}
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "1rem 0",
                        }}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="hierarchy-boundary-sub-heading2">
                          {trimming(hierItem?.boundaryType)}
                        </div>
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "1rem 0",
                        }}
                      />
                    </div>
                  );
                }
              } else {
                return (
                  <div key={index}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="hierarchy-boundary-sub-heading2">
                        {trimming(hierItem?.boundaryType)}
                      </div>
                    </div>
                    <hr
                      style={{ borderTop: "1px solid #ccc", margin: "1rem 0" }}
                    />
                  </div>
                );
              }
            })}
          </Card>
          {/* Second Card: Upload Section with Download Template */}
          <Card
            type={"primary"}
            variant={"viewcard"}
            className={"example-view-card"}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Button
                icon="DownloadIcon"
                label={t("DOWNLOAD_EXCEL_TEMPLATE")}
                onClick={downloadExcelTemplate}
                size="medium"
                variation="secondary"
              />
            </div>

            {/* Upload File Section */}
            <div className="boundary-excel-upload-wrapper">
              <TextBlock
                body={t("UPLOAD_EXCEL_DESCRIPTION")}
                subHeader={t("UPLOAD_EXCEL")}
                subHeaderClassName={"boundary-excel-subheader"}
              />
              {/* BulkUploadNew Component */}
              <BulkUploadNew
                onSubmit={handleBulkUploadSubmit}
                fileData={uploadedFileData}
                onFileDelete={handleFileDelete}
                onFileDownload={handleFileDownload}
              />
            </div>

            {/* Error Alert */}
            {uiValError && (
              <div style={{ marginTop: "1rem" }}>
                <AlertCard
                  label="Error"
                  text={uiErrorMsg}
                  variant="error"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            )}
          </Card>
          {/* Info Alert Card */}
          <div style={{ marginTop: "1rem" }}>
            <AlertCard
              label={t("INFO")}
              text={t("BOUNDARY_DOWNLOAD_MESSAGE")}
              variant="default"
              style={{ maxWidth: "100%" }}
            />
          </div>
          {/* Footer with Back and Submit buttons */}
          <Footer
            actionFields={[
              <Button
                icon="ArrowBack"
                label={t("COMMON_BACK")}
                onClick={() => {
                  navigate(
                    `/${window.contextPath}/employee/workbench/boundary/home`,
                    { state: { mdmsModuleName } }
                  );
                }}
                type="button"
                variation="secondary"
                textStyles={{ width: "unset" }}
              />,
              <Button
                icon="ArrowForward"
                isDisabled={disableFile || dataCreationGoing}
                style={{ marginLeft: "auto" }}
                isSuffix
                label={t("SUBMIT_EXCEL")}
                onClick={() => {
                  createData();
                }}
                type="button"
                variation="primary"
                textStyles={{ width: "unset" }}
              />,
            ]}
            className="custom-action-bar"
            maxActionFieldsAllowed={5}
            sortActionFields
            style={{}}
          />
          {/* Loader during data creation */}
          {dataCreationGoing && (
            <Loader page={true} variant={"OverlayLoader"} />
          )}
          {/* Toast notification */}
          {showToast && (
            <Toast
              label={showToast.label}
              type={showToast.isError}
              onClose={() => setShowToast(null)}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
};
export default ViewHierarchy;
